import React from 'react';
import classnames from 'classnames';

// Components
import { WpContainer, WpContainerBody, Padding } from 'Wpds/components/container';

// Types
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './EmptyStateContainer.scss';

type Props = {
  title?: string;
  titleTag?: 'h3' | 'h4' | 'h5';
  subTitle?: string | React.ReactNode;
  image?: Illustrations;
  button?: React.ReactNode;
  inContainer?: boolean;
  grayBackground?: boolean;
  padding?: Padding;
};

const EmptyStateContainer = ({
  title,
  titleTag = 'h3',
  subTitle,
  image,
  button,
  inContainer = false,
  grayBackground = false,
  padding = 24,
}: Props) => {
  const baseClassName = 'EmptyStateContainer';
  const classes = classnames(
    baseClassName,
    grayBackground ? `${baseClassName}--gray-bg` : '',
    !inContainer ? `${baseClassName}--p-${padding}` : ''
  );

  const CustomTitleTag = titleTag;

  const body = (
    <div className={`${baseClassName}__inner`}>
      <div className={`${baseClassName}__inner__wrapper`}>
        {title && <CustomTitleTag className={`${baseClassName}__title`}>{title}</CustomTitleTag>}
        {subTitle && <p className={`${baseClassName}__sub-title`}>{subTitle}</p>}
        {button && <div className={`${baseClassName}__button`}>{button}</div>}
        {image && <WpIllustration className={`${baseClassName}__img`} src={image} alt={title} />}
      </div>
    </div>
  );

  return (
    <>
      {inContainer ? (
        <WpContainer className={classes}>
          <WpContainerBody padding={padding}>{body}</WpContainerBody>
        </WpContainer>
      ) : (
        <div className={classes}>{body}</div>
      )}
    </>
  );
};

export default EmptyStateContainer;
